"use client";

import { useContext } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const { user, role, loading, logout } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center p-2">
        <Spinner animation="border" size="sm" /> <span className="ms-2">در حال بارگذاری...</span>
      </div>
    );
  }

  if (!user) return null; // اگر هنوز لاگین نکرده

  const fullName = `${user.name || "-"} ${user.family || ""}`.trim();
  const avatar = user.avatar || "/images/user-22.jpg";
  
  let role_name = '';
  switch(user.role) {
    case 'ADMIN': role_name = 'ادمین'; break;
    case 'STORE': role_name = 'فروشگاه'; break;
    case 'USER': role_name = 'کاربر'; break;
  }

  // 🔹 خروج از حساب
  const handleLogout = () => {
    logout(); // پاک کردن توکن و user از Context
    navigate("/authentication/login"); // هدایت به صفحه ورود
  };

  return (
    <>
      <Dropdown className="admin-profile">
        <Dropdown.Toggle className="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor">
          <div className="flex-shrink-0">
            <img
              className="rounded-circle wh-40 administrator"
              src={avatar}
              alt={fullName}
              width={40}
              height={40}
            />
          </div>

          <div className="flex-grow-1 ms-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-none d-xxl-block">
                <div className="d-flex align-content-center">
                  <h3>{fullName}</h3>
                </div>
              </div>
            </div>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu className="border-0 bg-white dropdown-menu-end">
          <div className="d-flex align-items-center info">
            <div className="flex-shrink-0">
              <img
                className="rounded-circle wh-30 administrator"
                src={avatar}
                alt={fullName}
                width={30}
                height={30}
              />
            </div>
            <div className="flex-grow-1 ms-2">
              <h3 className="fw-medium">{fullName}</h3>
              <span className="fs-12">{role_name || "-"}</span>
            </div>
          </div>

          <ul className="admin-link ps-0 mb-0 list-unstyled">
            {/* <li>
              <Link
                to="/store/profile"
                className={`dropdown-item d-flex align-items-center text-body ${
                  pathname === "/store/profile" ? "activeLink" : ""
                }`}
              >
                <i className="material-symbols-outlined">account_circle</i>
                <span className="ms-2">پروفایل کاربری</span>
              </Link>
            </li> */}

            {/* <li>
              <Link
                to="/store/wallet"
                className={`dropdown-item d-flex align-items-center text-body ${
                  pathname === "/store/wallet" ? "activeLink" : ""
                }`}
              >
                <i className="material-symbols-outlined">credit_card</i>
                <span className="ms-2">کیف پول</span>
              </Link>
            </li> */}

            {/* <li>
              <Link
                to="/apps/chat"
                className={`dropdown-item d-flex align-items-center text-body ${
                  pathname === "/apps/chat" ? "activeLink" : ""
                }`}
              >
                <i className="material-symbols-outlined">chat</i>
                <span className="ms-2">Messages</span>
              </Link>
            </li>

            <li>
              <Link
                to="/apps/to-do-list"
                className={`dropdown-item d-flex align-items-center text-body ${
                  pathname === "/apps/to-do-list" ? "activeLink" : ""
                }`}
              >
                <i className="material-symbols-outlined">
                  format_list_bulleted
                </i>
                <span className="ms-2">My Task</span>
              </Link>
            </li> */}
          </ul>

          <ul className="admin-link ps-0 mb-0 list-unstyled">
            {/* <li>
              <Link
                to="/settings/account-settings"
                className={`dropdown-item d-flex align-items-center text-body ${
                  pathname === "/settings/account-settings" ? "activeLink" : ""
                }`}
              >
                <i className="material-symbols-outlined">settings</i>
                <span className="ms-2">Settings</span>
              </Link>
            </li>

            <li>
              <Link
                to="/helpdesk/tickets"
                className={`dropdown-item d-flex align-items-center text-body ${
                  pathname === "/helpdesk/tickets" ? "activeLink" : ""
                }`}
              >
                <i className="material-symbols-outlined">support</i>
                <span className="ms-2">Support</span>
              </Link>
            </li>

            <li>
              <a
                href="/authentication/lock-screen"
                className="dropdown-item d-flex align-items-center text-body"
              >
                <i className="material-symbols-outlined">lock</i>
                <span className="ms-2">Lock Screen</span>
              </a>
            </li> */}

            <li>
              <a
                href="/authentication/logout"
                className="dropdown-item d-flex align-items-center text-body"
              >
                <i className="material-symbols-outlined">logout</i>
                <span className="ms-2">خروج</span>
              </a>
            </li>
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default Profile;
